export const goHome = async (
  router: any,
  interviewId: any,
  jobId: any,
  data: any
) => {
  if (interviewId) {
    await router.push({
      pathname: `/interview/${interviewId}/demo`,
      query: { jobId: jobId || data?.book?._id },
    });
    return;
  }

  await goToModulesPage(router, data?.book?._id, data?.chapter?._id);
};

export const goToModulesPage = async (
  router: any,
  bookId?: string,
  chapterId?: string
) => {
  await router.push(
    {
      pathname: "/home/training",
      query: { id: bookId, moduleId: chapterId },
    },
    undefined,
    { shallow: true }
  );
};
